import { connect } from 'react-redux'

import { DateMenus } from '@components/groupOrders'

import coordinators from '@coordinators'
import services from '@services'
import presenters from '@presenters'
import { HandleError } from '@coordinators/composed'

const mapStateToProps = (state: any) => {
  const { dateMenus, changedDateMenuMap, autoStagedMenus } = state.groupOrder
  const { lastLoggedInHq, locale } = state.user
  const currentHq = state.headquarter.headquarters.find(
    (h: any) => h.id === lastLoggedInHq,
  )
  const groupOrderMinimumItems = currentHq
    ? currentHq.groupOrderMinimumItems
    : null

  return {
    locale,
    headquarter: lastLoggedInHq,
    dateMenus,
    changedDateMenuMap,
    autoStagedMenus,
    groupOrderMinimumItems,
  }
}

const mapDispatchToProps = () => {
  const {
    pMergeItemWithMods,
    pResponseGroupOrderConcept,
    pResponseGroupOrderConcepts,
    pRequestSaveDateMenu,
    pResponseDateMenu,
  } = presenters.Api
  const { RestService, UIService, GroupOrdersService } = services
  const {
    DeleteDateMenus,
    GetGroupOrderBySettingsDate,
    GetGroupOrderConcept,
    SaveDateMenu,
    SearchAvailableChefs,
    SearchGroupOrderConcepts,
    LoadMenuItemRatings,
    ValidatePickupTimes,
    GetConceptEstPricePerPerson,
    FetchAndMergeMenuItemModifications,
  } = coordinators

  const {
    newDateMenu,
    setChangedDateMenuMap,
    updateDateMenus,
    setAutoStagedMenus,
  } = GroupOrdersService
  const deleteDateMenus = DeleteDateMenus({
    RestService,
    UIService,
    HandleError,
  })
  const saveDateMenu = SaveDateMenu({
    RestService,
    UIService,
    HandleError,
    pRequestSaveDateMenu,
    pResponseDateMenu,
  })
  const getGroupOrderBySettingsDate = GetGroupOrderBySettingsDate({
    RestService,
  })
  const getGroupOrderConcept = GetGroupOrderConcept({
    RestService,
    pResponseGroupOrderConcept,
    HandleError,
  })
  const searchGroupOrderConcepts = SearchGroupOrderConcepts({
    RestService,
    pResponseGroupOrderConcepts,
    HandleError,
  })
  const searchAvailableChefs = SearchAvailableChefs({
    RestService,
    HandleError,
  })
  const fetchAndMergeMenuItemModifications = FetchAndMergeMenuItemModifications(
    {
      RestService,
      pMergeItemWithMods,
    },
  )
  const loadMenuItemRatings = LoadMenuItemRatings({ RestService })
  const getConceptEstPricePerPerson = GetConceptEstPricePerPerson({
    RestService,
    HandleError,
  })
  const validateChefPickupTimes = ValidatePickupTimes({
    RestService,
    UIService,
    HandleError,
  })
  const {
    displayFailureMessage,
    displayWarningMessage,
    displaySuccessMessage,
  } = UIService.FlashMessage
  const { show: showConfirmationModal } = UIService.ConfirmationModal
  const showCustomModal = UIService.InfoModal.displayInfoModal

  return {
    deleteDateMenus,
    getGroupOrderBySettingsDate,
    fetchAndMergeMenuItemModifications,
    getGroupOrderConcept,
    newDateMenu,
    setAutoStagedMenus,
    setChangedDateMenuMap,
    updateDateMenus,
    saveDateMenu,
    showConfirmationModal,
    showCustomModal,
    searchAvailableChefs,
    searchGroupOrderConcepts,
    displayFailureMessage,
    loadMenuItemRatings,
    displaySuccessMessage,
    displayWarningMessage,
    validateChefPickupTimes,
    getConceptEstPricePerPerson,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DateMenus)
